<!-- v1.5 - in use -->
<template>
 <div><!-- This component will dynamically inject styles after page load --></div>
</template>


<script src="./ctrl-color-map.js"></script>
